module.exports = __webpack_public_path__ + "img/btn-btn-my-left-p.1d1b9dba.svg";